import { render, staticRenderFns } from "./OrderPreview.vue?vue&type=template&id=762518dc&scoped=true"
import script from "./OrderPreview.vue?vue&type=script&lang=js"
export * from "./OrderPreview.vue?vue&type=script&lang=js"
import style0 from "./OrderPreview.vue?vue&type=style&index=0&id=762518dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762518dc",
  null
  
)

export default component.exports